
export const getNextId = () => (new Date().getTime() + Math.random()).toString(36).toUpperCase();

export default {
  getNextId,
};
